<p-select #dropdown [options]="filterOptions" [(ngModel)]="selectedOption" *ngIf="showDropdown" optionLabel="name"
  optionValue="value" optionDisabled="disabled" (onChange)="handleChange($event)" [autoDisplayFirst]="false"
  [disabled]="disableField" placeholder="Select" appendTo="body">
  <ng-template let-filter pTemplate="item">
    <div class="action-item" [ngClass]="filter.value">
      <div>{{filter.name}}</div>
    </div>
  </ng-template>
</p-select>